import React from "react";
import { Card, CardMedia, CardContent, CardActions, Typography, useTheme, useMediaQuery, Box, Button } from "@mui/material";

//import useStyles from "./styles";

const CartItem = ({ item, products, onUpdateCartQty, onRemoveFromCart }) => {
  //const classes = useStyles();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleUpdateCartQty = (lineItemId, newQuantity) => onUpdateCartQty(lineItemId, newQuantity);
  const handleRemoveFromCart = (lineItemId) => onRemoveFromCart(lineItemId);

  //----------------------------------------------
  const getInventory = (SKU) => {
    let prod = products.filter((product) => product.SKU === SKU);
    return prod[0].Quantity;
  };

  let inventory = getInventory(item.sku);

  console.log("Product Inventory: " + inventory);
  return (
    <Card
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        transition: "transform 0.15s ease-in-out",
        "&:hover": {
          transform: "scale(1.02)"
        }
      }}
    >
      <CardMedia
        image={process.env.REACT_APP_API_HOST + item.imageUrl}
        alt={item.productName}
        sx={{
          height: isMobile ? 180 : 250,
          objectFit: "contain",
          p: 1
        }}
      />
      <CardContent sx={{ flexGrow: 1, p: isMobile ? 1 : 2 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
          <Typography variant="h6">{item.productName}</Typography>
          <Typography variant="h6">{item.total}</Typography>
        </Box>
      </CardContent>
      <CardActions sx={{ p: isMobile ? 0.5 : 1, mt: "auto" }}>
        <Button type="button" size="small" onClick={() => handleUpdateCartQty(item.cartItemId, item.quantity - 1)}>
          <Typography variant="h6">-</Typography>
        </Button>
        <Typography variant="h6">&nbsp;{item.quantity}&nbsp;</Typography>
        <Button type="button" size="small" onClick={() => handleUpdateCartQty(item.cartItemId, item.quantity + 1)} hidden={!(inventory > item.quantity)}>
          <Typography variant="h6">+</Typography>
        </Button>

        <Button variant="contained" type="button" color="secondary" onClick={() => handleRemoveFromCart(item.cartItemId)}>
          Remove
        </Button>
      </CardActions>
    </Card>
  );
};

export default CartItem;
